<template>
   <template v-if="d_data.pemeriksaan_hantar == 1">
      <div class="grow ">
         <div class="w-flex wrap smd-column" >
           <div class="grow ">
             <table >
              <tbody>
               <tr class="row_data">
                  <td><b>  % Motiliti Progresif beku sperma pada (35-37C) </b></td>
                  <td><b>:</b></td>
                  <td>{{form_data.motiliti}}</td>
               </tr>
               <tr class="row_data">
                  <td><b>  Pemeriksa dan penilai </b></td>
                  <td><b>:</b></td>
                  <td>{{form_data.name}}</td>
               </tr>
                <tr class="row_data">
                  <td><b> Sel lain daripada Sperma </b></td>
                  <td><b>:</b></td>
                  <td>{{form_data.sel_lain}}</td>
               </tr>
               </tbody>
            </table>
              </div>
              <div class="mx2"></div>
              <div class="grow ">
            <table>
              <tbody>
               <tr class="row_data">
                  <td><b> % Sperma hidup </b></td>
                  <td><b>:</b></td>
                  <td>{{form_data.sperma_hidup}}</td>
               </tr>
               <tr class="row_data">
                  <td><b> % Sperma cacat </b></td>
                  <td><b>:</b></td>
                  <td>{{form_data.sperma_cacat}}</td>
               </tr>
               </tbody>
            </table>
              </div>
              <div class="mx2"></div>
              <div class="grow ">
            <table class="table-status">
              <tbody>
               <tr class="row_data">
                  <td><b> Status </b></td>
                  <td><b>:</b></td>
                  <td>{{form_data.status_label}}</td>
               </tr>
               <tr class="row_data">
                  <td><b> Catatan </b></td>
                  <td><b>:</b></td>
                  <td>{{form_data.catatan}}</td>
               </tr>
               </tbody>
            </table>
         </div>
      </div>
   </div> 
   </template>
   <template v-else>
      <w-form class="" v-model="form_data.valid" v-model:errors-count="form_data.errorsCount" @validate="onValidate" @success="onSuccess()" >
        <div class="w-flex wrap smd-column" >
          <div class="grow " >
            <w-input class="mt4"  label="% Motiliti Progresif beku sperma pada (35-37C)  *" type="number" v-model="form_data.motiliti" :validators="[validators.required]" /><br>
            <w-input class="mb2" label="Pemeriksa dan Penilai *" label-position="inside" inner-icon-right="wi-search"
              v-model="form_data.name" @click="pengguna()" :validators="[validators.required]">
            </w-input>
               <w-input class="mt4"  label="Sel lain daripada sperma   *" type="text" v-model="form_data.sel_lain" :validators="[validators.required]"/>
          </div>
          <div class="mx2"></div>
            <div class="grow " >
              <w-input class="mt4"  label="% sperma hidup *" type="number" v-model="form_data.sperma_hidup" :validators="[validators.required]"/>
              <w-input class="mt4"  label="% sperma cacat  *" type="number" v-model="form_data.sperma_cacat" :validators="[validators.required]"/>
            </div>
          <div class="mx2"></div>
            <div class="grow " >
               <w-select class="mt4" :items="status_mp" label="Status *"  v-model="form_data.lkp_status_id"  :validators="[validators.required]" />
                <w-textarea class="mt4"  label="Catatan *"  v-model="form_data.catatan" :validators="[validators.required]" v-if="form_data.lkp_status_id == 24"/>
                <w-textarea class="mt4"  label="Catatan"  v-model="form_data.catatan"  v-else/>
          </div>
         </div>
        <w-flex class="mt3" wrap align-center justify-end>
          <w-button class="my1"   :loading="form_data.submitted && !form_data.sent" @click="send(2), onSuccess()">
              <w-icon dark tile class="mr2" >fal fa-save</w-icon> SIMPAN
          </w-button>&nbsp;
          <w-button class="my1" bg-color="success" type="submit" :disabled="form_data.valid === false" :loading="form_data.submitted && !form_data.sent" @click="send(1)">
              <w-icon xs class="mr2">fal fa-paper-plane</w-icon> HANTAR
          </w-button>
        </w-flex>
      </w-form>
   <w-dialog v-model="dialog.show" :fullscreen="dialog.fullscreen" :width="dialog.width" :persistent="dialog.persistent" :persistent-no-animation="dialog.persistentNoAnimation" title-class="primary-dark1--bg white">
         <template #title>
            <w-icon class="mr2">fal fa-cog</w-icon>
            Pilih Pemeriksa dan Penilai 
         </template>
         <w-form 
            ref="form" 
            v-model="dialog.valid"
            @validate="submit"
            @success="success"
         >
             <w-flex justify-center align-center>
                 <div class="xs8">
                     <w-input
                         label="No id | Nama"
                         v-model="carian_profil.q"
                     >
                     </w-input>
                 </div>
                 <div class="xs4">
                     <w-button class="ml1" @click="cariProfil">Cari</w-button>

                     <w-button 
                         class="ml1" 
                         @click="tambahPrfile()"
                         >
                         Tambah
                     </w-button>
                 </div>
             </w-flex>
           <div class="w-table-wrap" style="max-height: 400px;">
             <div class="table-profil-scrol">
             <table class="w-table" color="light" >
               <thead>
                 <tr>
                   <th class="w-table__header  text-left" width="1%">No</th>
                   <th class="w-table__header  text-left">Nama</th>
                   <th class="w-table__header  text-left">E-mel</th>
                   <th class="w-table__header  text-left">Nombor Telefon</th>
                   <th class="w-table__header  text-left">Pilih</th>
                  <th class="w-table__header  text-left">Padam</th>
                 </tr>
               </thead>

               <tbody>
                 <template v-if="user_list.length == 0">
                   <tr class="w-table__row" >
                     <td class="w-table__cell text-left" colspan="20"> Tiada Data.</td>
                   </tr>
                 </template>
                 <template v-for="(dt, ind) in user_list">
                   <tr class="w-table__row" >
                     <td class="w-table__cell text-left" >{{ind+1}}</td>
                     <td class="w-table__cell text-left" >{{dt.no_id}} | {{dt.label}}</td>
                     <td class="w-table__cell text-left" >{{dt.email}}</td>
                     <td class="w-table__cell text-left" >{{dt.no_tel}}</td>
                     <td class="w-table__cell text-center">
                       <template v-if="form.pembekal_id == dt.value">
                          <w-radio
                           class="mr2"
                           v-model="form.pembekal_id"
                           @click="pilihProfil(dt)"
                         ></w-radio>
                       </template>
                       <template v-else>
                         <w-radio
                           class="mr2"
                           @click="pilihProfil(dt)"
                         ></w-radio>
                       </template>

                     </td>
                     <td class="w-table__cell text-left" >
                        <w-button class="fs-2" bg-color="error-dark1" dark tile @click="destroy1(dt.value)">
                          <w-icon xs >fal fa-trash</w-icon>
                        </w-button>
                     </td>
                   </tr>
                 </template>
               </tbody>
             </table>
             </div>
           </div>
         </w-form>
         <template #actions>
            <div class="spacer" />
            <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
         </template>
      </w-dialog>
      <w-dialog
         v-model="dialog_add.show"
         :fullscreen="dialog_add.fullscreen"
         :width="dialog_add.width"
         :persistent="dialog_add.persistent"
         :persistent-no-animation="dialog_add.persistentNoAnimation"
         title-class="primary-dark1--bg white">
         <template #title>
            <w-icon class="mr2">fal fa-cog</w-icon>
            Tambah profil
         </template>

         <w-form 
            ref="form" 
            v-model="dialog_add.valid"
            @validate="submitProfil"
            @success="success"
         >
         <div class="spacer"></div>
           <w-flex wrap :gap="2">
             <div class="grow mb4" style="min-width: 200px">
               <w-input
              outline
              label="No. Kad Pengenalan *"
              class="mt3"
              type="text"
              placeholder="No. Kad Pengenalan"
              name="no_id"
              v-model="form_profil.no_id"
              :validators="[validators.required]"
            />
               <div class="spacer"></div>
               <br>
               <w-input
               outline
               label="Emel *"
               class="mt3"
               type="email"
               placeholder="Sila Masukkan Emel"
               name="email"
               v-model="form_profil.email"
               :validators="[validators.required, validators.email]"
            />
             </div>
             <div class="grow mb4" style="min-width: 200px">
               <w-input
              outline
              label="Nama Penuh *"
              class="mt3"
              type="text"
              placeholder="Nama Penuh"
              name="name"
              v-model="form_profil.name"
              :validators="[validators.required]"
            />
               <div class="spacer"></div>
               <br>
               <w-input
                outline
                label="Nombor Telefon *"
                class="mt3"
                type="tel"
                placeholder="Sila Masukkan Nombor Telefon"
                name="no_tel"
                v-model="form_profil.no_tel"
                :validators="[validators.required, validators.numeric]"
            />
             </div>
           </w-flex>
           <!-- <div class="spacer"></div>
           <w-textarea 
               outline 
               label="Alamat*"
               placeholder="Sila Masukkan Alamat"
               class="mt3"
               name="alamat"
               v-model="form_profil.alamat"
               type="text-area"
               :validators="[validators.required]"/>
           <div class="spacer"></div>
           <br>
           <template v-if = "form.p == 1">
            <w-select 
               outline
               :items="poskod" 
               label="Poskod"  
               v-model="form.lkp_poskod_id"
               @input="checkPoskod()"
               />
           </template>
           <template v-else>
             <w-input
                outline
                label="Poskod"
                class="mt3"
                type="tel"
                placeholder="Sila Masukkan Poskod"
                name="poskod"
                v-model="form_profil.kode"
                @change="getPoskodUtama()"
                :validators="[validators.required, validators.numeric]"
            />
           </template>
           <br>
           <w-select 
               outline
               :items="bandar" 
               label="Bandar *"  
               v-model="form_profil.lkp_bandar_id"
               @input="getPoskod(1)"
               :validators="[validators.required]"/>
           <div class="spacer"></div>
           <br>
           <w-select 
               outline
               :items="negeri" 
               label="Negeri *"  
               v-model="form_profil.lkp_negeri_id"
               @input="getBandar(1)"
               :validators="[validators.required]"/> -->
         </w-form>
           

       
         <template #actions>
            <div class="spacer" />
            <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog_add.show = false">TUTUP</w-button>
            <w-button  class="ml1" 
            :loading="dialog_add.loading"
            :disabled="dialog_add.valid === false"
            @click="$refs.form.validate()"
            >
              SIMPAN
            </w-button>
         </template>
      </w-dialog>
	</template>  
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'



export default {
  extends: ZResource,
  props: {
    d_data: [Array, Object],
    
  },
  data() {
    return {
     
      form_data : {
      	lkp_ternakan_id : '',
      	lkp_baka_id : '',
      	se_katalog_id : '',
      	se_pemungutan_id : '',
      	motiliti : '',
      	lkp_status_id : '',
      	sperma_hidup : '',
         sperma_cacat : '',
         sel_lain : '',
         user_id : '',
         name:'',
         hantar : 2
      },
      data: this.d_data,
      status_mp : [],
      negeri :[],
      carian_profil: { q: "" },
      country : [],
      bandar : [],
      poskod : [],
      negara : [],
      peran : [],
      form_profil: [],
      user_list: [],
      dialog: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 800,
      },
      dialog_add: {
         valid: false,
         show: false,
         fullscreen: false,
         persistent: true,
         persistentNoAnimation: false,
         loading: false,
         width: 800,
         item: {name: '', email: '', mobile: ''}
      },
      
    }
  },
  methods: {
   destroy1(id){
      this.$swal({
        title: 'Anda Pasti?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak'
      }).then((result) => {
        if (result.value) {
          this.$zcomm.delete('pengguna.destroy',{ id: id , pemeriksa:1},{})
          .then(res => {
            // this.sending = false;
            // this.$inertia.visit(this.$page.url)

            this.$zutil.notify("Berjaya dipadam", 'error');
            this.getUserList();
            // this.removeitem(res) // remove the data from list. no need to refresh page
            if (typeof this.onAfterDelete === "function") {
            }
          })
          .finally(() => {
            // $('#' + this.resourceurl).modal('hide')
          });
        }else{ }
        })
   },
   send(hantar){
      this.form_data.hantar = hantar
   },
    
   onSuccess(){

      if(this.form_data.hantar == 1){
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            this.$zcomm.post('se.kawalan.store', {
              lkp_ternakan_id : this.data.lkp_ternakan_id,
              lkp_baka_id : this.data.lkp_baka_id,
              se_katalog_id : this.data.se_katalog_id,
              se_pemungutan_id : this.data.id,
              motiliti : this.form_data.motiliti,
              sperma_hidup : this.form_data.sperma_hidup,
              sperma_cacat : this.form_data.sperma_cacat,
              sel_lain : this.form_data.sel_lain,
              user_id : this.form_data.user_id,
              lkp_status_id : this.form_data.lkp_status_id,
              catatan : this.form_data.catatan,
              hantar : this.form_data.hantar
            })
            .then(res => {
              if (typeof this.onAfterAdd === "function") {
                this.onAfterAdd()
              }

              this.$zutil.notify ("Rekod telah berjaya disimpan")
              // this.getData()
              this.$inertia.visit(this.$route('se.kawalan.show',this.data.id)+'?t=0')
              // this.$inertia.visit(this.$route('se.katalog.show', res.id))

            });
          }
        });
      }else{
        this.$zcomm.post('se.kawalan.store', {
          lkp_ternakan_id : this.data.lkp_ternakan_id,
          lkp_baka_id : this.data.lkp_baka_id,
          se_katalog_id : this.data.se_katalog_id,
          se_pemungutan_id : this.data.id,
          motiliti : this.form_data.motiliti,
          sperma_hidup : this.form_data.sperma_hidup,
          sperma_cacat : this.form_data.sperma_cacat,
          sel_lain : this.form_data.sel_lain,
          user_id : this.form_data.user_id,
          lkp_status_id : this.form_data.lkp_status_id,
          catatan : this.form_data.catatan,
        })
        .then(res => {
          if (typeof this.onAfterAdd === "function") {
            this.onAfterAdd()
          }

          this.$zutil.notify ("Rekod telah berjaya disimpan")
          // this.getData()
          this.$inertia.visit(this.$route('se.kawalan.show',this.data.id)+'?t=0')
          // this.$inertia.visit(this.$route('se.katalog.show', res.id))

        })
      }
      
   },

   getStatusMp(){
      
      this.$zcomm.get(this.api_service + 'lookup/status_mp', {}).then(res => {
        this.status_mp = res
      })
   },

   getData(){
      this.$zcomm.get(this.api_service + 'se_pemungutan/pemeriksaan/'+this.data.id, {}).then(res => {
        if(res.s == 1){
          this.form_data = res
        }
      })
   },

   getNegara(){
      this.$zcomm.get(this.api_service + 'lookup/negara', {}).then(res => {
        this.negara = res
      })
   },

   getBandar(item){
      if (item == 2) {
        this.form_profil.lkp_poskod_id = '';
        this.form_profil.lkp_bandar_id = '';
      }
      if(item == 2 || (item == 1 && this.form_profil.lkp_bandar_id != '')){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form_profil.lkp_negeri_id, {}).then(res => {
        this.bandar = res
        })
      }
      if(item == 0){
        this.$zcomm.get(this.api_service + 'lookup/bandar/'+this.form_profil.lkp_negeri_id, {}).then(res => {
        this.bandar = res
        })
      }
   },

   getPoskod(item){
      if (item == 2 || this.form_profil.lkp_bandar_id == '') {
      this.form_profil.lkp_poskod_id = '';
      }
      if(item == 2 || (item == 1 && this.form_profil.lkp_bandar_id != '')){
      this.$zcomm.get(this.api_service + 'lookup/poskod/'+this.form_profil.lkp_bandar_id, {}).then(res => {
        this.poskod = res
      })
      }
    },

   getPoskodUtama(){
      this.$zcomm.get(this.api_service + 'lookup/poskod_utama/'+this.form_profil.kode, {}).then(res => {
        // this.form.p = res.p
        this.form_profil.lkp_negeri_id = res.lkp_negeri_id
        this.form_profil.lkp_bandar_id = res.lkp_bandar_id
        this.form_profil.lkp_poskod_id = res.lkp_poskod_id
        this.getPoskod(0)
        this.getBandar(0)
      })
    },

   checkPoskod(){
      if(this.form_profil.lkp_poskod_id == null){
         this.form_profil.p = 0
      }
    },

   tambahPrfile(){
      this.form_profil = {
           id : null,
           no_id : null,
           name : null,
           email:'',
           no_tel: '',
           alamat: '',
           password: 123123,
           pembekal: null,
           status : 1,
           kode: '',
           lkp_poskod_id: '',
           lkp_bandar_id : '',
           lkp_negeri_id :'',
           pemeriksa:1,
      }
      this.dialog_add.show = true
      this.form_profil.saveButton = "Save"
    },

   submitProfil(){
      this.$zcomm.post('pengguna',this.form_profil).then(res => {
          if (res == "No. Kad Pengenalan sudah wujud!" || res == "Email sudah wujud!") {
            if (res == "No. Kad Pengenalan sudah wujud!")
                {
                  this.$zutil.notify("No. Kad Pengenalan sudah wujud!", false);
                }
            if (res == "Email sudah wujud!")
                {
                  this.$zutil.notify("Email sudah wujud!", false);
                }
          }else{
            this.$zutil.notify("Berjaya disimpan");
            this.getUserList();
            this.dialog_add.show = false;
          }
        })
        .catch(err => {
        })
   },

   pengguna(){
      this.getUserList();
      this.dialog.show = true
      this.form_data.saveButton = "Save"
   },

   pilihProfil(dt) {
        this.form_data.user_id = dt.value;
        this.form_data.name = dt.label;
        this.dialog.show = false
   },

   cariProfil() {
        if (this.carian_profil.q.length > 1) {
            this.$zcomm
                .get(
                    this.api_service + "lookup/user_list/3",
                    this.carian_profil,
                    {}
                )
                .then((res) => {
                    this.user_list = res;
                });
        }
   },

   getUserList(){
      this.$zcomm.get(this.api_service + 'lookup/user_list/3', {}).then(res => {
        this.user_list = res
      })
   },  
   getNegeri(){
      this.$zcomm.get(this.api_service + 'lookup/negeri/1', {}).then(res => {
         this.negeri = res
         this.load = this.load + 1
      })
   },

    
  
  },

  watch: {

  },
  mounted() {
    
   	this.getStatusMp()
   	this.getData()
      this.getNegeri()
    
  }
    
}
</script>
